import { Injectable } from '@angular/core';
import {
  CtButtonConfiguration,
  CtCardConfiguration,
  CtCardIconConfiguration,
  CtCardIconPosition,
} from '@ctsolution/ct-framework';
import { CtWebapiGenericResponse, CtWebapiService, DataRequest } from '@ctsolution/ct-webapi';
import { CTConfigurationModel } from '../../../_core/classes/ct-configuration-model';
import { CtManagerService } from '../../../_core/lib/ct-manager.service';

@Injectable()
export class DashboardBiHelper {

  constructor(
    private webapi: CtWebapiService,
    private managerService: CtManagerService,
  ) {}

  /**
   * Aggiunge la card "Reportistica" alla masterCardList solo se biConfiguration è abilitata.
   * Visibilità di default: `false` — backward-compatible, attivabile per-client tramite getComponentOverride.
   */
  async getBiWidget(masterCardList: CtCardConfiguration[]): Promise<void> {

    const biConfiguration: CTConfigurationModel = CTConfigurationModel.create();

    await this.managerService.getComponentOverride('dashboard', 'biConfiguration', biConfiguration);

    // Se non abilitata per questo client, interrompiamo qui senza aggiungere nulla
    if (!biConfiguration.biConfiguration) return;

    REPORTISTICA_CARD.setAction(() => this.openBiReport());

    masterCardList.push(REPORTISTICA_CARD);

  }

  /**
   * Chiama GET BI/GetAccess, legge l'URL SSO dal Result e lo apre in una nuova scheda.
   * In caso di risposta anomala o errore HTTP, logga in console senza interrompere l'UX.
   */
  private openBiReport(): void {

    const request: DataRequest = DataRequest
      .create()
      .setController(['BI'])
      .setAction('GetAccess');

    this.webapi
      .get<string>(request)
      .subscribe({
        next: (response: CtWebapiGenericResponse<string>) => {

          const url: string | null = response?.Result ?? null;

          if (!url) {
            // ⚠️ Risposta valida ma Result assente o vuoto: caso anomalo, verificare il backend
            console.warn('[DashboardBiHelper] BI/GetAccess ha restituito un Result nullo o vuoto.');
            return;
          }

          window.open(url, '_blank');

        },
        error: (err) => {
          // ⚠️ Errore HTTP: non blocca la dashboard, solo log diagnostico
          console.error('[DashboardBiHelper] Errore durante la chiamata BI/GetAccess:', err);
        }
      });

  }

}

// ---------------------------------------------------------------------------
// Card definition — visible: false di default (backward-compatible)
// ---------------------------------------------------------------------------
export const REPORTISTICA_CARD: CtCardConfiguration = CtCardConfiguration.create()
  .setTitle('dashboard.reportisticaLabel')
  .setDescription('dashboard.reportisticaDescription')
  .setIconSetting(
    CtCardIconConfiguration.create()
      .setIcon('bar_chart')
      .setPosition(CtCardIconPosition.SUFFIX)
      .setClass('bg-white text-ct-manager')
  )
  .setClass('bg-ct-manager text-white')
  .setButton(CtButtonConfiguration.create().setIcon('arrow_forward'));
